import './about.css';
import AboutImage from '../../assets/about2.png'
import CV from '../../assets/Enes_Chatzi_Osman_Public_CV.pdf'
import { HiDownload } from "react-icons/hi";

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="" />
          </div>
        </div>
        <div className="about__right">
          <h2>About Me</h2>
          <p>
            I am a Computer Engineer focused on developing backend applications using Java and Spring Boot.
          </p>
          <p>
            I’m currently developing my skills in Java, Spring Boot, REST APIs, PostgreSQL and software design. 
            I enjoy building practical applications, learning new technologies and improving my problem-solving and software engineering skills.
          </p>
          <p>
            In addition to software development, I also have professional experience in IT Technical Support -troubleshooting, networking and system installation.
          </p>
          <div className="about__cta">
             <a href={CV} download className='btn primary'>Download CV <HiDownload/></a>
             <a href="#portfolio" className='btn primary'>View My Projects</a>
          </div>
          
        </div>
      </div>
    </section>
  )
}

export default About 